import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { cn } from '@/lib/utils/cn';
import { PRIMARY_NAV } from './navConfig';

export interface BottomNavProps {
  onOpenMore: () => void;
}

export function BottomNav({ onOpenMore }: BottomNavProps) {
  const pathname = usePathname();

  return (
    <nav
      aria-label="Navegação principal (mobile)"
      className={cn(
        'fixed inset-x-0 bottom-0 z-50 md:hidden',
        'border-t border-slate-200/80 dark:border-white/8',
        'bg-white/90 dark:bg-[#1a1a1a]/90 backdrop-blur-xl',
        'pb-[var(--app-safe-area-bottom,0px)]'
      )}
    >
      <div className="mx-auto flex h-[var(--app-bottom-nav-height,56px)] max-w-screen-sm items-stretch">
        {PRIMARY_NAV.map((item) => {
          const isActive =
            item.href
              ? pathname === item.href || (item.href === '/boards' && pathname === '/pipeline')
              : false;

          const Icon = item.icon;

          if (item.id === 'more') {
            return (
              <button
                key={item.id}
                type="button"
                onClick={onOpenMore}
                className={cn(
                  'relative flex flex-1 flex-col items-center justify-center gap-0.5 pt-1.5',
                  'text-[10px] font-medium tracking-wide',
                  'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200',
                  'focus-visible-ring transition-colors'
                )}
              >
                <span className="flex items-center justify-center w-10 h-6 rounded-full">
                  <Icon className="h-5 w-5" aria-hidden="true" />
                </span>
                <span>{item.label}</span>
              </button>
            );
          }

          return (
            <Link
              key={item.id}
              href={item.href!}
              className={cn(
                'relative flex flex-1 flex-col items-center justify-center gap-0.5 pt-1.5',
                'text-[10px] font-medium tracking-wide focus-visible-ring transition-colors',
                isActive
                  ? 'text-primary-600 dark:text-primary-400'
                  : 'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200'
              )}
              aria-current={isActive ? 'page' : undefined}
            >
              <span
                className={cn(
                  'flex items-center justify-center w-10 h-6 rounded-full transition-all duration-200',
                  isActive
                    ? 'bg-primary-100/80 dark:bg-primary-900/40'
                    : ''
                )}
              >
                <Icon
                  className={cn('h-5 w-5', isActive ? 'text-primary-600 dark:text-primary-400' : '')}
                  aria-hidden="true"
                />
              </span>
              <span>{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
